import React from "react";
import { useEffect } from "react";
import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import { getUser } from "../../utils/localStorage";

import api from "../../utils/api";
import { useState } from "react";

import { toast } from "react-toastify";
import Spinner from "../../common/Spinner/Spinner";
import { ControlledInput } from "../../common/Input/Input";
import { Button } from "../../common/Button/Button";
import Select from "react-select";
import CentralizedNotesModal from "../../components/ServiceRequests/Handholder/CentralizedNotesModal";
import UserDetails from "../../components/ServiceRequests/ThreeSixtyDegreeView/UserDetails";
import NotesModalThreeSixtyDegreeView from "../../components/ServiceRequests/ThreeSixtyDegreeView/NotesModalThreeSixtyDegreeView";
import ServiceDetailsContainer from "./ServiceDetailsContainer";
import { useLocation } from "react-router-dom";
import Radio from "../../common/Radio/Radio.jsx";
import CentralizedSMSLogModal from "../../components/ServiceRequests/Handholder/CentralizedSMSLogModel";
function useQuery() {
	return new URLSearchParams(useLocation().search);
}

export default function ThreeSixtyDegreeViewContainer(props) {
	const params = useQuery();

	const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	const phonePattern = /^\d{10}$/;
	const [totalUsers, setTotalUsers] = useState([]);
	const [isLoadingServicesLPM, setIsLoadingServicesLPM] = useState(false);
	const [isLoadingServicesSPM, setIsLoadingServicesSPM] = useState(false);

	const [servicesLPM, setServicesLPM] = useState([]);
	const [servicesLPMCount, setServicesLPMCount] = useState(0);
	const [servicesLPMByUserId, setServicesLPMByUserId] = useState({});

	const [servicesSPMSectionA, setServicesSPMSectionA] = useState([]);
	const [ServicesSPMSectionACount, setServicesSPMSectionACount] = useState(0);
	const [
		servicesSPMSectionAByUserId,
		setServicesSPMSectionAByUserId,
	] = useState({});

	const [servicesSPMSectionB, setServicesSPMSectionB] = useState([]);
	const [ServicesSPMSectionBCount, setServicesSPMSectionBCount] = useState(0);
	const [
		servicesSPMSectionBByUserId,
		setServicesSPMSectionBByUserId,
	] = useState({});

	const [servicesLS, setServicesLS] = useState([]);
	const [servicesLSSorted, setServicesLSSorted] = useState([]);

	const pagination = false;

	const [userData, setUserData] = useState();
	const [userDataWP, setUserDataWP] = useState([]);
	const [userDataWPByUserId, setUserDataWPByUserId] = useState([]);
	const [nUserId, setNUserId] = useState();

	const [searchFilter, setSearchFilter] = useState();
	const onSearchFilterChange = (option) => {
		setSearchFilter(option);
	};
	const [showNotesMddal, setShowNotesModal] = useState(false);
	const [selectedService, setSelectedService] = useState();
	const [notesDetails, setNotesDetails] = useState({
		sFollowupAction: "",
		dtFollowupOn: "",
		sNotes: "",
	});

	const [selectedCustomerEmailForNotes, setselectedCustomerEmailForNotes] = useState(null);
	const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	const toggleViewAllNotesModal = (email) => {
		setselectedCustomerEmailForNotes(email);
		setShowViewAllNotesModal(!showViewAllNotesModal);
	};

	const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	const toggleViewAllSMSModal = (email) => {
		setselectedCustomerEmailForNotes(email);
		setShowViewAllSMSModal(!showViewAllSMSModal);
	};

	const [selectedSearchBy, setSelectedSearchBy] = useState('Email');

	const sortServicesLS = () => {
		let searchParam =
			searchTerm && emailPattern.test(searchTerm) === "email"
				? "sEmailAddress"
				: "sContactNumber";
				if(selectedSearchBy==="InstanceID")
				{
					searchParam="sEmailAddress";
				}
		let searchParamLS =
			searchParam === "sEmailAddress" ? "EmailAddress" : "Phone";
		let temp = [];
		for (var i = 0; i < servicesLS.length; i++) {
			servicesLPM.map((s) => {
				if (
					s[`${searchParam}`] === servicesLS[i][`${searchParamLS}`] ||
					(servicesLS[i][`${searchParamLS}`] && s[`${searchParam}`] ===
						servicesLS[i][`${searchParamLS}`].split("-")[1])
				) {
					servicesLS[i]["nUserId"] = s["nUserId"];
				}
			});
			temp.push(servicesLS[i]);
		}
		let temp1 = [];
		if (servicesLS.length !== 0) {
			temp1 = servicesLS.reduce((r, a) => {
				r[a.EmailAddress] = r[a.EmailAddress] || [];
				r[a.EmailAddress].push(a);
				return r;
			}, Object.create(null));
		}
		setServicesLSSorted(temp1);
	};

	const sortUserDataByUserId = () => {
		let temp = [];
		console.log("WP data", userDataWP.data);

		if (
			userDataWP.data !== undefined &&
			userDataWP.data.data !== null &&
			Object.keys(userDataWP).length > 0
		) {
			temp = userDataWP.data.data.reduce((r, a) => {
				r[a.email] = r[a.email] || [];
				r[a.email].push(a);
				return r;
			}, Object.create(null));
		}
		setUserDataWPByUserId(temp);
	};

	const sortServicesLPMByUserId = () => {
		let temp = [];
		temp = servicesLPM.filter((e) => e.bMovedToSPM === false);
		if (temp.length !== 0) {
			temp = temp.reduce((r, a) => {
				r[a.sEmailAddress] = r[a.sEmailAddress] || [];
				r[a.sEmailAddress].push(a);
				return r;
			}, Object.create(null));
		}
		setServicesLPMByUserId(temp);
	};
	const [existIDs, setExistIDs] = useState([]);
	const sortServicesSPMSectionAByUserId = () => {
		let temp = [];
		let ids = [];
		if (servicesSPMSectionA.length !== 0) {
			temp = servicesSPMSectionA.reduce((r, a) => {
				r[a.sEmailAddress] = r[a.sEmailAddress] || [];
				r[a.sEmailAddress].push(a);
				ids.push(a.nResourceInstanceId)
				return r;
			}, Object.create(null));
		}
		setExistIDs(ids);
		setServicesSPMSectionAByUserId(temp);
	};

	const sortServicesSPMSectionBByUserId = () => {
		let temp = [];
		let email_id = "";
		if (servicesSPMSectionB.length !== 0) {
			temp = servicesSPMSectionB.reduce((r, a) => {
				r[a.sEmailAddress] = r[a.sEmailAddress] || [];
				email_id = a.sEmailAddress;
				if (!existIDs.includes(a.nResourceInstanceId)) {
					r[a.sEmailAddress].push(a);
				}
				return r;

			}, Object.create(null));
		}

		if (email_id !== "") {
			temp[email_id].length === 0 ? setServicesSPMSectionBByUserId([]) : setServicesSPMSectionBByUserId(temp);
		}
		else {
			setServicesSPMSectionBByUserId([]);
		}
	};


	const toggleNotesModal = (nResourceInstasnceId) => {
		setSelectedService(nResourceInstasnceId);
		setShowNotesModal(!showNotesMddal);
	};
	const onInputChange = (name, value) => {
		const updated = { ...notesDetails, [name]: value };
		setNotesDetails(updated);
	};
	const onSaveNotesDetails = async () => {
		if (
			notesDetails["sNotes"] === "" ||
			notesDetails["sNotes"] === undefined ||
			notesDetails["sNotes"] === null
		) {
			toast("Notes field is mandetory", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			!(notesDetails["dtFollowupOn"] && notesDetails["sFollowupAction"])
		) {
			if (
				(notesDetails["sFollowupAction"] === "" ||
					notesDetails["sFollowupAction"] === null ||
					notesDetails["sFollowupAction"] === undefined) &&
				(notesDetails["dtFollowupOn"] === "" ||
					notesDetails["dtFollowupOn"] === undefined ||
					notesDetails["dtFollowupOn"] === null)
			) {
			} else if (
				notesDetails["dtFollowupOn"] === "" ||
				notesDetails["dtFollowupOn"] === undefined ||
				notesDetails["dtFollowupOn"] === null
			) {
				toast("Followup Date is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else if (
				notesDetails["sFollowupAction"] === "" ||
				notesDetails["sFollowupAction"] === undefined ||
				notesDetails["sFollowupAction"] === null
			) {
				toast("Followup Action is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else {
			}
		}

		try {
			if (true) {
				let data = await api
					.saveNotes({
						...notesDetails,
						nResourceInstanceId:
							selectedService["nResourceInstanceId"],
					})
					.then(() => {
						toast("Note saved successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					});

				setNotesDetails({
					sFollowupAction: "",
					dtFollowupOn: "",
					sNotes: "",
				});
			}
			toggleNotesModal();
		} catch (error) {
			toast(String(error.response.statusText), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const assignToMeClick = async (e) => {
		let nResourceInstanceIds = servicesLPMByUserId[e].map(
			(f) => f["nResourceInstanceId"]
		);
		const loggedInHH = getUser();

		const data = await api
			.assignToMe({
				nResourceInstanceIds: nResourceInstanceIds,
			})
			.then((response) => {
				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				} else {
					toast("Service Requests assigned successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}

				getAllServices();
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const getUserData = async () => {
		let searchFilterParams;
		if (servicesLPM.length > 0) 
		{
			if (searchTerm) {
				if(selectedSearchBy==="InstanceID")
				{
					searchFilterParams = {
						SearchBy: "email",
						SearchValue: servicesLPM[0].sEmailAddress,
					};
				}
				else{
					if (phonePattern.test(searchTerm)) {
						searchFilterParams = {
							SearchBy: "contact_number",
							SearchValue: searchTerm,
						};
					} else {
						searchFilterParams = {
							SearchBy: "email",
							SearchValue: searchTerm,
						};
					}
				}
				
			}
			if(searchFilterParams.SearchValue)
			{
				const wp_user = await api
				.getUserProfileWP(searchFilterParams)
				.then((d) => {
					setUserDataWP(d);
				});
			}
			const { data } = await api.getUserProfileData({
				nUserId: servicesLPM[0]["nUserId"],
			});
			if (data) setUserData(data);
		}
		//Added by abhijit for migrated services
		else if(servicesSPMSectionA.length>0)
		{
			if (searchTerm) {
				if(selectedSearchBy==="InstanceID")
				{
					searchFilterParams = {
						SearchBy: "email",
						SearchValue: servicesSPMSectionA[0]["sEmailAddress"],
					};
				}
				else{
					if (phonePattern.test(searchTerm)) {
						searchFilterParams = {
							SearchBy: "contact_number",
							SearchValue: searchTerm,
						};
					} else {
						searchFilterParams = {
							SearchBy: "email",
							SearchValue: searchTerm,
						};
					}
				}
			}

			if(searchFilterParams.SearchValue)
			{
				const wp_user = await api
				.getUserProfileWP(searchFilterParams)
				.then((d) => {
					setUserDataWP(d);
				});
			}
			
			const { data } = await api.getUserProfileData({
				nUserId: servicesSPMSectionA[0]["nUserId"],
			});
			if (data) setUserData(data);
		}
		
		//End added for Migrated services
	};
	useEffect(() => {
		sortUserDataByUserId();
	}, [userDataWP]);
	useEffect(() => {
		sortServicesLS();
	}, [servicesLPMByUserId]);
	useEffect(() => {
		getUserData();
		sortServicesLPMByUserId();
	}, [servicesLPM,servicesLS,servicesSPMSectionA]);
	//}, [servicesLPM, servicesLS); removed by abhijit for migrated services user profile
	useEffect(() => {
		sortServicesSPMSectionAByUserId();
	}, [servicesSPMSectionA]);
	useEffect(() => {
		sortServicesSPMSectionBByUserId();
	}, [servicesSPMSectionB]);
	useEffect(() => {
		getServicesLS();
	}, [servicesLPM,servicesSPMSectionA]);

	const updateTotalusers = () => {
		let tempTotalUsers = [];
		if (Object.keys(servicesLSSorted).length > 0) {
			Object.entries(servicesLSSorted).map(([key, value]) => {
				if (tempTotalUsers.includes(key) === false) {
					tempTotalUsers.push(key);
				}
			});
		}
		if (Object.keys(servicesLPMByUserId).length > 0) {
			Object.entries(servicesLPMByUserId).map(([key, value]) => {
				if (tempTotalUsers.includes(key) === false) {
					tempTotalUsers.push(key);
				}
			});
		}
		if (Object.keys(servicesSPMSectionAByUserId).length > 0) {
			Object.entries(servicesSPMSectionAByUserId).map(([key, value]) => {
				if (tempTotalUsers.includes(key) === false) {
					tempTotalUsers.push(key);
				}
			});
		}
		if (Object.keys(servicesSPMSectionBByUserId).length > 0) {
			Object.entries(servicesSPMSectionBByUserId).map(([key, value]) => {
				if (tempTotalUsers.includes(key) === false) {
					tempTotalUsers.push(key);
				}
			});
		}

		setTotalUsers(tempTotalUsers);
	};
	useEffect(() => {
		updateTotalusers();
	}, [
		servicesLPMByUserId,
		servicesSPMSectionAByUserId,
		servicesSPMSectionBByUserId,
		servicesLSSorted,
	]);
	const getServicesSPMSectionA = async (instance = false, flag = false) => {
		setServicesSPMSectionA([]);

		try {
			const { page } = {
				page: 0,
			};
			let searchFilterParams = null;
			let sortParams = null;

			if (searchTerm) {
				if(selectedSearchBy==="InstanceID")
				{
					searchFilterParams = {
						nResourceInstanceId: searchTerm,
					};
				}
				else
				{
					if (phonePattern.test(searchTerm)) {
						searchFilterParams = {
							Service_phone: searchTerm,
						};
					} else {
						searchFilterParams = {
							Service_email: searchTerm,
						};
					}
				}
			}
			const unassigned = null;
			const serviceRequestList = [];
			const followupInPast = null;
			const followupToday = null;
			const failedPayments = null;
			const statusList = [];
			const paymentStatus = [];
			const PackageList = [];
			setIsLoadingServicesSPM(true);
			const { data } = await api.getAllServicesSPM(
				page + 1,
				10,
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				followupInPast,
				followupToday,
				failedPayments,
				'all',
				PackageList,
				searchFilterParams,
				sortParams,
				flag,
				pagination
			);
			setIsLoadingServicesSPM(false);
			// let { results, count } = data;
			let results = data.map((e) => {
				if (e["customer_meta"]["email"]){
					e["sEmailAddressOrigin"] = e["sEmailAddress"]
					e["sEmailAddress"] = e["customer_meta"]["email"];
				}
				else e["sEmailAddressOrigin"] = "";
				if (e["refCurrentState"]["sServiceState"])
					e["refSRState"] = e["refCurrentState"]["sServiceState"];
				else e["refSRState"] = "";
				if (e["refFacilitator"])
					e["refFacilitator"] = e["refFacilitator"]["email"];
				else e["refFacilitator"] = "";
				return e;
			});
			setServicesSPMSectionA(results);
			setServicesSPMSectionACount(data.length);
		} catch (error) {
			console.error(error);
		}
	};
	const getServicesSPMSectionB = async (instance = false, flag = false) => {
		setServicesSPMSectionB([]);

		try {
			const { page } = {
				page: 0,
			};
			let searchFilterParams = null;
			let sortParams = null;

			if (searchTerm) {
				if(selectedSearchBy==="InstanceID")
				{
					searchFilterParams = {
						nResourceInstanceId: searchTerm,
					};
				}
				else
				{
					if (phonePattern.test(searchTerm)) {
						searchFilterParams = {
							C_phone: searchTerm,
						};
					} else {
						searchFilterParams = {
							C_email: searchTerm,
						};
					}
				}
				
			}
			const unassigned = null;
			const serviceRequestList = [];
			const followupInPast = null;
			const followupToday = null;
			const failedPayments = null;
			const statusList = [];
			const paymentStatus = [];
			const PackageList = [];
			setIsLoadingServicesSPM(true);
			const { data } = await api.getAllServicesSPM(
				page + 1,
				10,
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				followupInPast,
				followupToday,
				failedPayments,
				'all',
				PackageList,
				searchFilterParams,
				sortParams,
				flag,
				pagination
			);
			setIsLoadingServicesSPM(false);
			let results = data.map((e) => {
				if (e["customer_meta"]["email"]){
					e["sEmailAddressOrigin"] = e["sEmailAddress"];
					e["sEmailAddress"] = e["customer_meta"]["email"];
				}
				else e["sEmailAddressOrigin"] = "";
				if (e["refCurrentState"]["sServiceState"])
					e["refSRState"] = e["refCurrentState"]["sServiceState"];
				else e["refSRState"] = "";
				if (e["refFacilitator"])
					e["refFacilitator"] = e["refFacilitator"]["email"];
				else e["refFacilitator"] = "";
				return e;
			});
			setServicesSPMSectionB(results);
			setServicesSPMSectionBCount(data.length);
		} catch (error) {
			console.error(error);
		}
	};

	const getServicesLPM = async (instance = null, flag = false) => {
		setServicesLPM([]);

		try {
			const { page } = {
				page: 0,
			};
			let searchFilterParams = null;
			let sortParams = null;

			if (searchTerm) {
				if(selectedSearchBy==="InstanceID")
				{
					searchFilterParams = {
						nResourceInstanceId: searchTerm,
					};
				}
				else
				{
					if (phonePattern.test(searchTerm)) {
						searchFilterParams = {
							C_phone: searchTerm,
						};
					} else {
						searchFilterParams = {
							C_email: searchTerm,
						};
					}
				}				
			}
			// if (instance.state.sorted.length > 0) {
			// 	const { id, desc } = instance.state.sorted[0];
			// 	sortParams = { column: id, desc };
			// }

			const unassigned = null;
			const serviceRequestList = [];
			const PackageList = [];
			const failedPayments = null;
			const statusList = [];
			const paymentStatus = [];
			const followupDates = "";
			setIsLoadingServicesLPM(true);
			const { data } = await api.getAllServiceRequests(
				page + 1,
				10,
				'',
				'',
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				failedPayments,
				'all',
				'all',
				PackageList,
				searchFilterParams,
				sortParams,
				flag,
				pagination
			);
			setIsLoadingServicesLPM(false);

			setServicesLPM(data);
			setServicesLPMCount(data.length);
		} catch (error) {
			console.error(error);
		}
	};

	const getServicesLS = async () => {
		setServicesLS([]);

		try 
		{
			let sCustomerEmail='';
			if (servicesLPM.length > 0) 
			{
				sCustomerEmail=servicesLPM[0].sEmailAddress
			}
			else if(servicesSPMSectionA.length>0)
			{
				sCustomerEmail=servicesSPMSectionA[0]["sEmailAddress"]
			}

			let searchFilterParams;
			if (searchTerm) 
			{
				if(selectedSearchBy==="InstanceID")
				{
					searchFilterParams = {
						SearchBy: "EmailAddress",
						SearchValue: sCustomerEmail,
					};
				}
				else
				{
					if (phonePattern.test(searchTerm)) 
					{
						searchFilterParams = {
							SearchBy: "Phone",
							SearchValue: searchTerm,
						};
					}
					else 
					{
						searchFilterParams = {
							SearchBy: "EmailAddress",
							SearchValue: searchTerm,
						};
					}
				}
				if(searchFilterParams.SearchValue)
				{
					// setIsLoadingServicesLPM(true);
					const { data } = await api.getleadDetails(searchFilterParams);
					// setIsLoadingServicesLPM(false);
					setServicesLS(data);
				}
			}
			
		} catch (error) {
			console.error(error);
		}
	};

	const [searchTerm, setSearchTerm] = useState();

	const onSearchClicked = () => {
		getAllServices();
	};

	useEffect(() => {
		onSearchClicked()
	},[searchTerm])

	const onSearchByChange = (event) => {
		setSelectedSearchBy(event.target.textContent);
	};

	const onSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
	};

	const getAllServices = async() => {
		if (selectedSearchBy==="InstanceID"||emailPattern.test(searchTerm) || phonePattern.test(searchTerm)) {
			getServicesLPM();
			getServicesSPMSectionA();
			getServicesSPMSectionB();
			if(selectedSearchBy!="InstanceID")
			{
				getServicesLS();
			}
			
		}
	};
	useEffect(() => {
		if (params.get("email")) {
			setSearchTerm(params.get("email"));
			setSearchFilter({
				value: "email",
				label: "By email",
			});
		}
	}, []);
	// useDebouncedEffect(
	// 	() => {
	// 		getAllServices();
	// 	},
	// 	1000,
	// 	[searchTerm]
	// );
	return (
		<div style={{ justifyContent: "center" }}>
			<div className="row" style={{ justifyContent: "center" }}>
				<div className="col-md-3 mt-2">
					<div className={"_360-degree-view"}>
						<span style={{ float: "left",marginRight:"2px" }}>{"Enter "} </span>
						<Radio
							label="Email"							
							onClick={onSearchByChange}
							value={'Email'}
							checked={selectedSearchBy==="Email"}
						/>
						<Radio
							label="Phone"							
							onClick={onSearchByChange}
							value={'Phone'}
							checked={selectedSearchBy==="Phone"}
							style={{ float: "left" }}
						/>
						<Radio
							label="InstanceID"							
							onClick={onSearchByChange}
							value={'InstanceID'}
							checked={selectedSearchBy==="InstanceID"}
							style={{ float: "left" }}
						/>
					</div>
				</div>
				<div className="col-md-6">
					<ControlledInput
						placeholder="Search..."
						// onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
						onChange={onSearchInputChange}
						onKeyPress={(e) => {
							if (e.key === "Enter") {
								onSearchClicked();
							}
						}}
						value={searchTerm}
					/>
				</div>
				<div className="col-md-2">
					<Button onClick={onSearchClicked}>Search</Button>
				</div>
				<div className="col-md-1">
					<a href="/home/my-service-requests" target="_blank">
						To My Services
					</a>
				</div>
			</div>
			{totalUsers.length === 0 ? (
				<span>No data to display</span>
			) : (
					<ServiceDetailsContainer
						totalUsers={totalUsers}
						userDataWP={userDataWPByUserId}
						userData={userData}
						servicesLSSortedByUserId={servicesLSSorted}
						servicesLPMByUserId={servicesLPMByUserId}
						servicesSPMSectionAByUserId={servicesSPMSectionAByUserId}
						servicesSPMSectionBByUserId={servicesSPMSectionBByUserId}
						toggleNotesModal={toggleNotesModal}
						assignToMeClick={assignToMeClick}
						toggleViewAllNotesModal={toggleViewAllNotesModal}
						toggleViewAllSMSModal={toggleViewAllSMSModal}
					></ServiceDetailsContainer>
				)}

			<div>
				<NotesModalThreeSixtyDegreeView
					isOpen={showNotesMddal}
					toggleModal={toggleNotesModal}
					onInputChange={onInputChange}
					notesDetails={notesDetails}
					onSaveNotesDetails={onSaveNotesDetails}
				></NotesModalThreeSixtyDegreeView>
			</div>
			{
				showViewAllNotesModal&&
				(
					<CentralizedNotesModal
						isOpen={showViewAllNotesModal}
						toggleModal={toggleViewAllNotesModal}
						sEmailAddress={selectedCustomerEmailForNotes||""}
					>
					</CentralizedNotesModal>
				)
			}
			{
				showViewAllSMSModal&&
				(
					<CentralizedSMSLogModal
						isOpen={showViewAllSMSModal}
						toggleModal={toggleViewAllSMSModal}
						sEmailAddress={selectedCustomerEmailForNotes||""}
					>
					</CentralizedSMSLogModal>
				)
			}
		</div>
	);
}
